<app-header></app-header>

<div class="layout" [class.sidebar-collapsed]="collapsed()">
  <aside class="left">
    <div class="card">
      <div class="sidebar-header">
        <h2 class="title" *ngIf="!collapsed()">Onboarding Steps</h2>
        <button mat-icon-button (click)="toggleCollapsed()"
          [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'">
          <mat-icon>{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
      </div>
      <mat-vertical-stepper *ngIf="steps().length > 0" class="wizard-stepper" [selectedIndex]="selectedIndex()"
        (selectionChange)="onStepChange($event)">
        <ng-template matStepperIcon="number" let-active="active">
          <span class="indicator" [class.indicator--active]="active"></span>
        </ng-template>
        <ng-template matStepperIcon="edit">
          <span class="indicator indicator--active"></span>
        </ng-template>
        <ng-template matStepperIcon="done">
          <span class="indicator indicator--done">
            <mat-icon fontIcon="check"></mat-icon>
          </span>
        </ng-template>
        <ng-container *ngFor="let s of steps(); let i = index;">
          <mat-step [completed]="s.status === 'completed'">
            <ng-template matStepLabel>
              <div class="label-row" [matTooltip]="collapsed() ? labels()[s.step].title : ''"
                matTooltipPosition="right">
                <div class="label-titles">
                  <div class="label__title">
                      {{ labels()[s.step].title }}
                  </div>
                  <div class="label__subtitle" *ngIf="labels()[s.step].subtitle">
                    {{ labels()[s.step].subtitle }}
                  </div>
                </div>

                <div class="status-chip" [ngClass]="statusClass(s.status)">
                  {{ statusText[s.status] }}
                </div>
              </div>
            </ng-template>
              <div class="meta">
                <div class="content-2" *ngIf="s.updatedBy">Updated by: {{ s.updatedBy }}</div>
                <div class="content-2" *ngIf="s.updatedAt">Updated at: {{ s.updatedAt | date:'short' }}</div>
                <div class="content-2 muted" *ngIf="!s.updatedBy && !s.updatedAt">
                  No updates yet.
                </div>
              </div>
          </mat-step>
        </ng-container>
      </mat-vertical-stepper>
    </div>
  </aside>
  <main class="right">
    <div class="content">
      <mat-card *ngIf="showDemoAlert() && utilities.isDemoOnbValue" class="demo-alert sticky" appearance="outlined"
        role="status" aria-live="polite">
        <button mat-icon-button class="demo-alert__close" aria-label="Close demo notice" (click)="hideDemoAlert()">
          <mat-icon>close</mat-icon>
        </button>
        <div class="demo-alert__body">
          <mat-icon class="demo-alert__icon" aria-hidden="true">warning_amber</mat-icon>
          <div class="demo-alert__text">
            <div class="demo-alert__title">Demo Environment</div>
            <div class="demo-alert__desc">
              Actions and data here are temporary and will be discarded after the session.
            </div>
          </div>
        </div>
      </mat-card>

      <ng-container *ngIf="canSeeStepContent(); else noPermissionContent">
        <router-outlet></router-outlet>
      </ng-container>

      <ng-template #noPermissionContent>
        <div class="no-permission-container">
          <mat-icon class="svg-pending-steps" svgIcon="pending-step"></mat-icon>
          <h2 class="pending-alert" i18n>Onboarding processing.</h2>
          <p class="no-permission-desc" i18n>
            Your onboarding is currently being processed. Please check back later for updates.
          </p>
        </div>
      </ng-template>
    </div>
  </main>
</div>